export default __webpack_public_path__ + "static/13-9-sitzer-2-607cef53432647a548c3e2b33ea83439.jpg";